module.exports = __webpack_public_path__ + "img/38.60fc5425.jpg";